import { useState, useEffect } from "react";
import SettingStore from "stores/settings";

export const useDisplayLearningActivityCardImage = () => {
  const [displayImage, setDisplayImage] = useState(null);

  useEffect(() => {
    const fetchDisplaySetting = async () => {
      try {
        await SettingStore.init();
        const setting = SettingStore.getSettingValue("showcourseimageinportal");
        setDisplayImage(String(setting) === "1");
      } catch (error) {
        console.error("Error fetching display setting:", error);
        setDisplayImage(true); // Default to true on error
      }
    };

    fetchDisplaySetting();
  }, []);

  return displayImage;
};
